var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-layout"},[_c('DashboardSidebar'),_c('div',{staticClass:"dashboard-content"},[_c('router-view',{staticClass:"app-content-container"}),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }